import { TargetScoreRangeAgeGroup } from './types';

export const DEFAULT_TARGET_SCORE_RANGE_AGE_GROUP: TargetScoreRangeAgeGroup = '45To54';

export const FIRM_DEFAULTS_TARGET_SCORE_RANGE_TEMPLATE_ID = 'defaults';
